import uniqBy from 'lodash/uniqBy';

export const mapAppSubscriptions = (
  organisationId,
  communityAppId,
  existingApp,
  body,
  feature
) => ({
  organisation: { id: organisationId },
  communityApp: {
    id: communityAppId,
    communityAppFeatures: body
      ? uniqBy(
          [
            {
              appInstallationFeature: { tag: body.appInstallationFeature.tag },
            },
            ...(existingApp?.communityAppFeatures || [])
              .filter(f => f.requiresSubscription && f.appInstallationFeature?.tag !== body.tag)
              .map(f => ({
                appInstallationFeature: { tag: f.appInstallationFeature?.tag },
              })),
          ],
          'appInstallationFeature.tag'
        )
      : (existingApp?.communityAppFeatures || [])
          .filter(f => f.appInstallationFeature?.tag !== feature?.appInstallationFeature?.tag)
          .filter(f => f.requiresSubscription)
          .map(ca => ({
            appInstallationFeature: { tag: ca.appInstallationFeature?.tag },
          })),
  },
});
